<template>
  <div class="press">
    <a :href="content.btn[0].link.url">
      <img class="logo" :src="content.logo">
    </a>
    <h2 class="press-title">{{content.title}}</h2>
    <vue-markdown class="press-txt" v-html="content.desc"></vue-markdown>
    <custom-btn
      v-if="this.$route.meta.title == 'presse'"
      class="btn"
      :link="content.btn[0].link"
      :tab="content.btn[0].blank"
    >{{content.btn[0].label}}</custom-btn>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  props: {
    content: null
  }
};
</script>

<style lang="scss">
.press {
  max-width: 500px;
  height: auto;
  margin: auto;
  margin-bottom: 5em;
  .logo {
    margin: 1em 0;
  }
  .press-title {
    padding: 20px 0;
  }
  .press-txt {
    margin: 15px 0;
  }
  .btn.btn.inline {
    text-align: center;
  }
}
</style>
